import React from 'react';
import useFetch from '../../../../components/hooks/useFetch.js';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog.js';
import {
  CARTAO_POSTAGEM_EXCLUIR
} from '../../../../services/permissoesRecebidas.js';

function FormExcluirCartaoPostagem({
  acaoCancelar,
  acaoFechar,
  cartaoPostagemSelecionado,
  contratoSelecionado,
  idCorreios,
  idCorreiosPJ,
}) {
  const { request } = useFetch();
  const cancelar = (ev) => {
    ev.preventDefault();
    acaoCancelar();
  };

  const excluir = async () => {
    const { response } = await request(
      CARTAO_POSTAGEM_EXCLUIR(idCorreios, 
        idCorreiosPJ, 
        contratoSelecionado.nuContrato, 
        contratoSelecionado.contrato.nuSe, 
        cartaoPostagemSelecionado.nuCartaoPostagem),
    );

    if (response.ok) {
      abreAlertaDialog('Cartão Postagem excluido com sucesso!');
      acaoFechar();
    }
  };

  return (
    <>
      <div className="dialog-container">
        <div className="dialog-header">
          <h2>Excluir "{cartaoPostagemSelecionado?.nuCartaoPostagem}"</h2>
        </div>
        <div className="dialog-main" id="dialog-main-email">
          Tem certeza de que deseja excluir esse Cartão Postagem?
        </div>
        <div className="dialog-footer">
          <button className="btn-txt btn-fecha-dialog" onClick={cancelar}>
            Cancelar
          </button>
          <button className="btn-pre" id="btn-excluir" onClick={excluir}>
            Excluir
          </button>
        </div>
      </div>
    </>
  );
}
export default FormExcluirCartaoPostagem;
